export const GET_REQUEST = 'resetPassword/GET_REQUEST'
export const GET_SUCCESS = 'resetPassword/GET_SUCCESS'
export const GET_FAILURE = 'resetPassword/GET_FAILURE'
export const PUT_REQUEST = 'resetPassword/PUT_REQUEST'
export const PUT_SUCCESS = 'resetPassword/PUT_SUCCESS'
export const PUT_FAILURE = 'resetPassword/PUT_FAILURE'

export const UPDATE_USER_ID = 'resetPassword/UPDATE_USER_ID'